import React from 'react';
import styled from 'styled-components'

const Wrapper = styled.div`
    height : 120px;
    width : 100%;
    margin : 0;
    margin-top : -4px;
`
function PageBreakDefault() {
  return (
    <Wrapper/>
  )
}

export default PageBreakDefault